import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                accent: '#82B1FF',
                error: '#EC6960',
                info: '#2196F3',
                primary: '#6E99D9',
                secondary: '#8EACD7',
                success: '#4CAF50',

                // custom
                background: '#ECECEC',
                grayBackground: '#BCBEC6',
                grayText: '#777777',
                orangeLike: '#E66E5A',
                primaryText: '#528FE9',
                quaternary: '#F4ED46',
                secondaryBackground: '#dfdfdf',
                stripedOddRowBackground: '#f0f8ff',
                successIcons:'#EB8670',
                tertiary: '#F1F5FA',
            },
            dark: {
                // custom
                stripedOddRowBackground: '#333',
                grayText: '#777777',
            },
        },
    },
});
